// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a5190469","455":"d7bcce92","977":"4ae399da"}[chunkId] + ".chunk.js";
};